import { API_NAMES, initApi } from "../../../utils/HttpApiHelper";

const getOfferingTypesForClubRegistration = (orgUnitId, isOrganizationRegistration, state, setState) => {
    if (orgUnitId.length > 0) {
        const api = initApi(API_NAMES.OMR, state, setState);

        const orgUnitIdForUrl = orgUnitId ? encodeURIComponent(orgUnitId) : 'NaN';
        const url = `/OfferingType/ClubRegistration?orgUnitId=${orgUnitIdForUrl}&isOrganizationRegistration=${isOrganizationRegistration}`;

        // return api?.executeObject ? api.executeObject(url, 'GET') : null;

        return api?.executeArray ? api.executeArray(url, 'GET') : null;
    }
}

const NewOfferingTypeData = { 
    getOfferingTypesForClubRegistration
};

export default NewOfferingTypeData;